var _path, _g, _path2, _g2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1629",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 8,
    width: 20,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00049 8.79395H22.0001V22.5379H2.00049V8.79395Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1629)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5655 22.5379H6.43549C3.99049 22.5379 2.00049 20.5489 2.00049 18.1029V13.2279C2.00049 10.7829 3.99049 8.79395 6.43549 8.79395H7.36849C7.78249 8.79395 8.11849 9.12995 8.11849 9.54395C8.11849 9.95795 7.78249 10.2939 7.36849 10.2939H6.43549C4.81649 10.2939 3.50049 11.6099 3.50049 13.2279V18.1029C3.50049 19.7219 4.81649 21.0379 6.43549 21.0379H17.5655C19.1835 21.0379 20.5005 19.7219 20.5005 18.1029V13.2189C20.5005 11.6059 19.1885 10.2939 17.5765 10.2939H16.6335C16.2195 10.2939 15.8835 9.95795 15.8835 9.54395C15.8835 9.12995 16.2195 8.79395 16.6335 8.79395H17.5765C20.0155 8.79395 22.0005 10.7789 22.0005 13.2189V18.1029C22.0005 20.5489 20.0105 22.5379 17.5655 22.5379Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_67_1629",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 2,
    width: 2,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 2H12.75V15.5409H11.25V2Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_67_1629)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.541C11.586 15.541 11.25 15.205 11.25 14.791V2.75C11.25 2.336 11.586 2 12 2C12.414 2 12.75 2.336 12.75 2.75V14.791C12.75 15.205 12.414 15.541 12 15.541Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0852 6.42853C8.8942 6.42853 8.7022 6.35553 8.5562 6.20953C8.2632 5.91753 8.2612 5.44353 8.5542 5.14953L11.4692 2.22153C11.7502 1.93853 12.2502 1.93853 12.5312 2.22153L15.4472 5.14953C15.7392 5.44353 15.7382 5.91753 15.4452 6.20953C15.1512 6.50153 14.6772 6.50153 14.3852 6.20753L12.0002 3.81353L9.6162 6.20753C9.4702 6.35553 9.2772 6.42853 9.0852 6.42853Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.a7cf416048c976bee75e209a24bae30f.svg";
export { ForwardRef as ReactComponent };